/**
 * JavaScript representation of a Foundation component.
 * @constructor
 * @param {string|jQuery} component The component identifier string or jQuery object.
 * @extends {Foundation.Promise}
 */
Foundation.Component = function (component) {
    Foundation.Promise.call(this);

    /** @type {string} */
    this.id = Foundation.isString(component) ? component.replace(/^#/, "") : component.identify();

    /** @type {jQuery} */
    this.view = null;

    /** @type {jQuery} */
    this.fullView = null;

    var view = jQuery(`#${this.id}`);
    if (view[0]) {
        if (view[0].tagName.toLowerCase() === "body") {
            view = jQuery(`[id='${this.id}']`).not("body");
        }
        if (view[0]) this.setView(view);
    }

    /**
     * @type {Array.<Foundation.Form>}
     */
    this.forms = [];

    /**
     * @type {Array.<Foundation.Component>}
     */
    this.microComponents = [];
};
Foundation.inherit(Foundation.Component, Foundation.Promise);

/**
 * Sets the view of the component to the passed jQuery object and fulfills
 * the promise. You can only call this function once per instance.
 * @param {jQuery} view
 */
Foundation.Component.prototype.setView = function (view) {
    if (view[0]) {
        this.view = view.filter(`#${this.id}`);
        this.fullView = view;

        var domData = /** @type {Object.<string,string>} */ (this.view.data());
        this.extend(domData);

        this.fulfill();
    }
    else {
        this.fail();
    }
};

/**
 * Register a Foundation.Form.
 * @param {Foundation.Form} form
 * @return {Foundation.Form}
 */
Foundation.Component.prototype.registerForm = function (form) {
    this.forms.push(form);
    return form;
};

/**
 * Register a micro component, once it is ready.
 * @param {Foundation.Component} mc
 * @return {Foundation.Component}
 */
Foundation.Component.prototype.registerMicroComponent = function (mc) {
    mc.then(function () {
        this.microComponents.push(mc);
    }.bind(this));
    return mc;
};

/**
 * Find the first visible micro component.
 * @return {Foundation.Component}
 */
Foundation.Component.prototype.visibleMicroComponent = function () {
    for (var i = 0; i < this.microComponents.length; i++) {
        if (this.microComponents[i].view.is(":visible")) {
            return this.microComponents[i];
        }
    }

    return null;
};

/**
 * @return {Object}
 */
Foundation.Component.prototype.spinnerOptions = function () {
    return {};
};

/**
 * @return {Element}
 */
Foundation.Component.prototype.spinnerElement = function () {
    var foundSpinner = jQuery(`[data-spinner-for="${this.id}"]`);
    return foundSpinner[0] ? foundSpinner[0] : this.view[0];
};

/**
 * @param {Object=} options
 * @return {Foundation.Component}
 */
Foundation.Component.prototype.showSpinner = function (options) {
    if (!this.spinner) {
        var element = this.spinnerElement();
        options = Foundation.extend(this.spinnerOptions(), options);
        this.spinner = new Foundation.View.Spinner(element, options);
    }
    return this;
};

/**
 * @return {Foundation.Component}
 */
Foundation.Component.prototype.hideSpinner = function () {
    if (this.spinner) {
        this.spinner.hide();
        this.spinner = undefined;
    }
    return this;
};

/**
 * Destructor.
 * @override
 */
Foundation.Component.prototype.destroy = function () {
    this.hideSpinner();

    for (let i = 0; i < this.forms.length; i++) {
        this.forms[i].destroy();
    }

    for (let i = 0; i < this.microComponents.length; i++) {
        this.microComponents[i].destroy();
    }

    // Call the superclass's destructor.
    Foundation.Promise.prototype.destroy.call(this);
};

// ---------------------------------------------------------------------

window["Foundation"]["Component"] = Foundation.Component;
